import { motion } from "motion/react";
import { controlTransition } from "../../lib/motion";
import React from "react";

export function VioletBtn({ children, onClick, large = false }: { children: React.ReactNode; onClick?: () => void; large?: boolean }) {
  return (
    <motion.button
      whileHover={{ y: -2, scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      transition={controlTransition}
      onClick={onClick}
      className={`group inline-flex items-center gap-2 font-medium rounded-full bg-[#5B21B6] text-white dark:bg-[#7C4DFF] dark:text-[#050505] active:brightness-90 ${large ? "px-7 py-3.5 text-base" : "px-5 py-2.5 text-sm"}`}
    >
      {children}
    </motion.button>
  );
}

export function GhostBtn({ children, onClick }: { children: React.ReactNode; onClick?: () => void }) {
  return (
    <motion.button
      whileHover={{ y: -2, scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      transition={controlTransition}
      onClick={onClick}
      className="group inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium text-[#0A0A0F] dark:text-[#F5F5F7] border border-[#0A0A0F]/15 dark:border-white/15 rounded-full transition-colors hover:border-[#1E4FD8] dark:hover:border-[#4A90D9] hover:text-[#1E4FD8] dark:hover:text-[#8CC0F0] active:bg-[#0A0A0F]/5 dark:active:bg-white/10"
    >
      {children}
    </motion.button>
  );
}
